import { deleteData, getData, putData } from "../../helpers/url-request";
import { dashboardDefaults } from "./dashboardTypes";

const storageKey = (userId, view = "overview") =>
  `piers.dashboard.personal.${userId || "anonymous"}${
    view === "overview" ? "" : `.design-v2.${view}`
  }`;

const fromResponse = (response) => {
  if (response?.status === false)
    throw new Error(
      response.message || "Unable to load dashboard preferences."
    );
  return response?.data ?? response;
};

export const getPersonalDashboard = async (userId, view = "overview") => {
  // The existing server endpoint stores one layout; retain it for Overview only.
  if (view === "overview")
    try {
      const dashboard = fromResponse(await getData("/dashboard/personal"));
      if (dashboard?.widgets?.length) return dashboard.widgets;
    } catch (_) {
      // Offline and pre-migration environments retain the user's layout locally.
    }

  try {
    const saved = localStorage.getItem(storageKey(userId, view));
    return saved ? JSON.parse(saved) : dashboardDefaults(view);
  } catch (_) {
    return dashboardDefaults(view);
  }
};

export const savePersonalDashboard = async (
  userId,
  widgets,
  view = "overview"
) => {
  const payload = { name: "My Dashboard", widgets };
  try {
    if (view === "overview")
      fromResponse(await putData("/dashboard/personal", payload));
  } catch (_) {
    // The local copy is deliberately kept so the experience remains usable while an API is unavailable.
  }
  localStorage.setItem(storageKey(userId, view), JSON.stringify(widgets));
};

export const resetPersonalDashboard = async (userId, view = "overview") => {
  try {
    if (view === "overview") await deleteData("/dashboard/personal");
  } catch (_) {
    /* API may not have been deployed yet. */
  }
  localStorage.removeItem(storageKey(userId, view));
  return dashboardDefaults(view);
};

export const getDashboardData = async () =>
  fromResponse(await getData("/dashboard/data"));
